import React from 'react';
import { signatureDishes } from '../data/menu';
export function PlatesSection() {
  const [feature, ...rest] = signatureDishes;
  return <section aria-labelledby="plates-title" className="w-full bg-forest-900 py-24 lg:py-32" data-id="element-42" data-mp="5963a707f42n">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-43" data-mp="1584jxesjva4">
        <div className="mb-14 flex flex-col gap-4 md:flex-row md:items-end md:justify-between" data-id="element-44" data-mp="3sdm0orzt9fd1">
          <h2 id="plates-title" className="font-serif text-5xl font-light text-cream-50 md:text-7xl" data-id="element-45" data-mp="3nej4zy5q0lhq">
            Dans l’assiette
          </h2>
          <p className="max-w-sm text-cream-100/70" data-id="element-46" data-mp="3ilpx51eygx1f">
            Quelques assiettes du moment. La carte suit le marché, elle n’est jamais tout à fait la même.
          </p>
        </div>

        <div className="grid gap-8 lg:grid-cols-12" data-id="element-47" data-mp="39nw2rw0r4dgw">
          <figure className="lg:col-span-7" data-id="element-48" data-mp="34n8h7pvakou2">
            <div className="overflow-hidden rounded-sm" data-id="element-49" data-mp="34m6vmrgngjy3">
              <img src={feature.image} alt={feature.name} className="aspect-[4/5] w-full object-cover lg:aspect-[5/6]" loading="lazy" data-id="element-50" data-mp="2zoopt9xxikub" />
            </div>
            <figcaption className="mt-5" data-id="element-51" data-mp="16uieuctzy244">
              <p className="font-serif text-3xl text-cream-50" data-id="element-52" data-mp="16vjs8nyhj0p0">{feature.name}</p>
              <p className="mt-1 text-sm text-cream-100/65" data-id="element-53" data-mp="t456i9d70le9">{feature.note}</p>
            </figcaption>
          </figure>

          <div className="grid gap-8 sm:grid-cols-2 lg:col-span-5 lg:grid-cols-1 lg:pt-24" data-id="element-54" data-mp="xz12tlpgpux6">
            {rest.map(dish => <figure key={dish.name} className="flex flex-col" data-id="element-55" data-mp="1pt2zpn5aob9b">
                <div className="overflow-hidden rounded-sm" data-id="element-56" data-mp="1pq8h815ud0ij">
                  <img src={dish.image} alt={dish.name} className="aspect-[4/3] w-full object-cover" loading="lazy" data-id="element-57" data-mp="1bs0h5kdidj35" />
                </div>
                <figcaption className="mt-4" data-id="element-58" data-mp="1gtpoaoxm1cly">
                  <p className="font-serif text-2xl text-cream-50" data-id="element-59" data-mp="clfw4e9o528">{dish.name}</p>
                  <p className="mt-1 text-sm text-cream-100/65" data-id="element-60" data-mp="5d9a0yxsl20o">{dish.note}</p>
                </figcaption>
              </figure>)}
          </div>
        </div>
      </div>
    </section>;
}